export const GUIDE_PATH_PAGES_MAPPING = {
  "514": [
      "55m",
      "56x",
      "59s",
      "5jd",
      "5q5",
      "5pm"
  ],
  "544": [
      "506",
      "53r",
      "4zx"
  ],
  "21v": [
      "55c"
  ],
  "3wj": [
      "40j",
      "416",
      "427",
      "44l",
      "45q",
      "47k",
      "4gp",
      "4h0",
      "4h2"
  ],
  "5dh": [
      "5n7"
  ],
  "5f3": [
      "55z",
      "1x1",
      "1x8"
  ],
  "5mj": [
      "5mq",
      "5mr",
      "5ms",
      "5mt"
  ],
  "61b": [
      "55z",
      "1x1",
      "1x8",
      "1zm",
      "21v",
      "55c",
      "1zh",
      "552",
      "1zg",
      "1y6",
      "554",
      "220"
  ],
  "62c": [
      "55z",
      "1x1",
      "1x8"
  ],
  "62d": [
      "55z",
      "1x1",
      "1x8",
      "1zm",
      "1zh",
      "1zg",
      "554",
      "1zj"
  ],
  "62f": [
      "55z",
      "1x1",
      "1x8",
      "1y6",
      "21v",
      "55c",
      "552",
      "220"
  ]
};
